import React, { useState, MouseEvent } from "react";

import { MenuItem, Grid } from "@mui/material";
import { useTranslation } from "react-i18next";
import { FiFilter } from "react-icons/fi";

import { Button } from "../../../../../components/Form";
import { Color } from "../../../../../components/Form/Button";
import Checkbox from "../../../../../components/Form/Checkbox";
import {
  FilterButton,
  FilterHeader,
  IconCountFilter,
  ListContainer,
  MenuFilter,
  TextHeader,
  useStyles,
} from "./styles";

export type FilterOption = {
  checked: boolean;
  value: string;
  key?: unknown;
};

interface Props {
  filterOptions: FilterOption[];
  setFilterOptions: (values: FilterOption[]) => void;
}

const FilterCompany = ({ filterOptions, setFilterOptions }: Props) => {
  const { t: translate } = useTranslation();
  const classes = useStyles();

  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [options, setOptions] = useState<FilterOption[]>(filterOptions);

  const handleClick = (event: MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
    setOptions(filterOptions);
  };

  const handleFilter = () => {
    setFilterOptions(options);
    setAnchorEl(null);
  };

  const countOptionsChecked = () => {
    return options?.filter((option) => option.checked)?.length ?? 0;
  };

  return (
    <Grid item xs={2}>
      <FilterButton
        onClick={handleClick}
        style={{
          backgroundColor: anchorEl ? "#03569E" : undefined,
        }}
      >
        <FiFilter size={15} color="#FFFFFF" />
        {countOptionsChecked() ? <IconCountFilter>{countOptionsChecked()}</IconCountFilter> : null}
      </FilterButton>
      <MenuFilter
        PaperProps={{
          className: classes.menuFilter,
        }}
        data-cy="menu-filter-by"
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={() => handleClose()}
        disableRestoreFocus
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        transformOrigin={{ horizontal: "right", vertical: "top" }}
        onKeyDown={(event) => {
          if (event?.key === "Enter") {
            handleFilter();
          }
        }}
      >
        <FilterHeader>
          <TextHeader data-cy="title">{translate("filters")}</TextHeader>
          <Button data-cy="button-save" customColor={Color.SECONDARY} onClick={handleFilter}>
            {translate("go")}
          </Button>
        </FilterHeader>
        <ListContainer data-cy="list-categories" aria-labelledby="nested-list-subheader">
          {options &&
            options?.length &&
            options?.map((option, index) => {
              return (
                <MenuItem key={index}>
                  <Checkbox
                    checked={option.checked}
                    label={option.value}
                    value={option}
                    onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                      const optionsMapped = options.map((optionMapped) => ({
                        ...optionMapped,
                        checked:
                          optionMapped.value === option.value && optionMapped.key === option.key
                            ? event?.target.checked
                            : optionMapped.checked,
                      }));

                      setOptions(optionsMapped);
                    }}
                  />
                </MenuItem>
              );
            })}
        </ListContainer>
      </MenuFilter>
    </Grid>
  );
};

export default FilterCompany;
